import React, { FC } from 'react';
import { OldWidget, OldWidgetProps } from './old';

const Widget: FC<OldWidgetProps> = (props) => {
  return <OldWidget {...(props as OldWidgetProps)} />;
};

export default Widget;
